import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import { Link } from 'react-router-dom';
import FaqItem from 'components/help/FaqItem';
import { DarkThemeProvider } from 'components/themes';
import useHelmet from 'components/common/useHelmet';
import { Link as MuiLink, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  main: {
    flexGrow: 1,
    flexShrink: 0,
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  content: {
    maxWidth: 800,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: {
      maxWidth: 1100,
    },
  },
  faqContainer: {
    width: '100%',
    color: '#fff',
    padding: theme.spacing(6, 2),
    backgroundColor: '#23333d',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contactsSection: {
    marginTop: theme.spacing(6),
    width: '100%',
  },
  contactsContent: {
    color: '#a5c8dc',
    borderTop: `1px solid #dfe4e7`,
    paddingTop: theme.spacing(5),
    width: '100%',
  },
}));

function Help() {
  const classes = useStyles();
  useHelmet(
    'Help and contacts',
    'Frequently asked questions, supported image formats, contact information',
    'https://photoutils.com/help'
  );

  return (
    <>
      <Header />
      <main>
        <DarkThemeProvider>
          <div className={classes.faqContainer}>
            <div className={classes.content}>
              <section>
                <Typography component="h1" color="inherit" align="center" variant="h2" className={classes.title}>
                  Frequently asked questions
                </Typography>
                <FaqItem question="What is PhotoUtils and do I need to pay anything?">
                  PhotoUtils is the online photo editor. Resize, convert, crop, compress, rotate, flip your images,
                  photos or pictures using its simple tools. No need need to pay anything, it's completely free!
                </FaqItem>
                <FaqItem question="Is it secure? Is it private?">
                  Your privacy and security is our top priority. We never ask you to register or provide any personal
                  information. We use an encrypted storage for all images that you upload or edit,{' '}
                  <MuiLink target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/HTTPS">
                    HTTPS
                  </MuiLink>{' '}
                  is always used to guarantee a secure communication between you and PhotoUtils. Images you upload are
                  never accessed by anyone, including PhotoUtils staff.
                </FaqItem>
                <FaqItem question="What happens to my images after I'm done editing?">
                  All images that you upload or edit are automatically completely removed within 30 minutes after you
                  are done
                </FaqItem>
                <FaqItem question="Which image formats are supported?">
                  Upload your images and download them after editing in the following formats:
                  <strong> JPG, PNG, WEBP, GIF, ICO, BMP, TIFF</strong>
                </FaqItem>
                <FaqItem question="Can I compress my image to reduce the file size?">
                  Sure! Go to the{' '}
                  <MuiLink to="/" component={Link}>
                    home page
                  </MuiLink>
                  , upload your image and use the
                  <strong> Compress</strong> tool to set the needed file size in MB or kB.
                </FaqItem>
                <FaqItem question="What is the maximum file size that I can upload?">
                  You can upload image up to 30 MB in size
                </FaqItem>
              </section>
              <section className={classes.contactsSection}>
                <Typography component="h2" align="center" variant="h2" className={classes.title}>
                  Other questions
                </Typography>
                <Typography
                  variant="h6"
                  align="left"
                  color="textSecondary"
                  component="p"
                  className={classes.contactsContent}
                >
                  Email us at <MuiLink href="mailto:support@photoutils.com">support@photoutils.com</MuiLink> for any
                  other questions
                </Typography>
              </section>
            </div>
          </div>
        </DarkThemeProvider>
      </main>
      <Footer />
    </>
  );
}

export default Help;
